import React , {Component} from "react";
import axios from 'axios';
import Message from './Message';
import Cookies from 'universal-cookie';
import {v4 as uuid} from 'uuid';
import Card from './Card';
import QuickReplies from './QuickReplies';



const cookies = new Cookies();

class Chatbot extends Component{
     
   messagesEnd;

    constructor(props){
         super(props);
         this._handleInputKeyDown = this._handleInputKeyDown.bind(this);
         this._handleQuickReplyPayload = this._handleQuickReplyPayload.bind(this);

           this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
       
         this.state = {
            messages: [],
            showBot: true,
        }  

        if(cookies.get('userID')=== undefined){
            cookies.set('userID', uuid(),{path:'/'});
        }
        
     }

    
    /* const handleQuery = async () => {
        try {
          const dialogflowEndpoint = 'https://www.twigaustralia.com.au/locating-tracking-services/webhook'; // Replace with your Dialogflow webhook URL
          const res = await fetch(dialogflowEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              queryInput: {
                text: {
                  text: query,
                  languageCode: 'en',
                },
              },
            }),
          });
    
          const result = await res.json();
          setResponse(result.fulfillmentText);
        } catch (error) {
          console.error('Error:', error);
          setResponse('Sorry, there was an error processing your request.');
        }
      };*/
    
       
    async df_text_query(queryText){
        let says={
            speaks: 'me',
            msg:{
                text:{
                    text:queryText
                }
            }
        }

        this.setState({ messages: [...this.state.messages, says]});
       const res = await axios.post('http://localhost:3000/api/df_text_query', {text:queryText, userID:cookies.get('userID')});
       //const res = await axios.post(`${window.location.origin}/api/df_text_query`, {text:queryText, userID:cookies.get('userID')});
      
         for(let msg of res.data.fulfillmentMessages){
           let says={
                speaks:'bot',
                msg:msg
            }

            console.log("here in query");
            this.setState({messages:[...this.state.messages, says]});
        }
            
    }

     async df_event_query(event){
         // const res= await axios.post('/api/df_event_query',{event:eventName});
    
          //  const res = await axios.post('http://localhost:5000/api/df_event_query',{event: event, userID:cookies.get('userID')});
            const res = await axios.post('http://localhost:3000/api/df_event_query',{event: event, userID:cookies.get('userID')});
           
          //  http://localhost/ashaiwork/
            for(let msg of res.data.fulfillmentMessages){
            console.log(JSON.stringify(msg));
              let says ={
                speaks:'bot',
                msg:msg
              }

              this.setState({messages:[...this.state.messages, says]});
           }  
        }
        componentDidMount(){
            this.df_event_query('welcome');
        }

        componentDidUpdate(){
            this.messagesEnd.scrollIntoView({behaviour:"smooth"});
            if ( this.talkInput ) {
                this.talkInput.focus();
            }
        } 
        
        
        show(event) {
            event.preventDefault();
            event.stopPropagation();
            this.setState({showBot: true});
        }
    
        hide(event) {
            event.preventDefault();
            event.stopPropagation();
            this.setState({showBot: false});
        }
        _handleQuickReplyPayload(event, payload, text) {
            event.preventDefault();
            event.stopPropagation();
    
            this.df_text_query(text);
    
        }

        renderCards(cards) {
            return cards.map((card, i) => <Card key={i} payload={card.structValue}/>);
        }

        renderOneMessage(message, i){
            if (message.msg && message.msg.text && message.msg.text.text) {
                return <Message key={i} speaks={message.speaks} text={message.msg.text.text}/>;
            } else if (message.msg && message.msg.payload.fields.cards) { //message.msg.payload.fields.cards.listValue.values
    
                return <div key={i}>
                    <div className="card-panel grey lighten-5 z-depth-1" style={{color:'blue',backgroundColor:'grey', border: '1px slild grey'}} >
                        <div style={{overflow: 'hidden'}}>
                            <div className="col s2">
                                <a href="/" className="btn-floating btn-large waves-effect waves-light blue">{message.speaks}</a>
                            </div>
                            <div style={{ overflow: 'auto', overflowY: 'scroll'}}>
                                <div style={{ height: 300, width:message.msg.payload.fields.cards.listValue.values.length * 270}}>
                                    {this.renderCards(message.msg.payload.fields.cards.listValue.values)}
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }else if (message.msg &&
                message.msg.payload &&
                message.msg.payload.fields &&
                message.msg.payload.fields.quick_replies
            ) {
                return <QuickReplies
                    text={message.msg.payload.fields.text ? message.msg.payload.fields.text : null}
                    key={i}
                    replyClick={this._handleQuickReplyPayload}
                    speaks={message.speaks}
                    payload={message.msg.payload.fields.quick_replies.listValue.values}/>;
            }
        }

     renderMessages(stateMessages){
         if(stateMessages){
        return stateMessages.map((message, i)=>{
            if (message.msg && message.msg.text && message.msg.text.text) {
                return <Message key={i} speaks={message.speaks} text={message.msg.text.text}/>;
            } else {
                 return this.renderOneMessage(message, i);
            }

            
         });
       }else{
        return null;
       }
     }   

     _handleInputKeyDown(e){
        console.log("here in key down")
         if(e.key === 'Enter'){
            this.df_text_query(e.target.value);
            e.target.value ='';
         }
     }

    render(){
        /*if (this.state.showBot) {
            return (
                <div style={{ minHeight: 500, maxHeight: 500, width:400, position: 'absolute', bottom: 150, right: 100, border: '1px solid lightgray'}}>
                    <nav>
                        <div className="nav-wrapper">
                            <a href="/" className="brand-logo">ChatBot</a>
                            <ul id="nav-mobile" className="right hide-on-med-and-down">
                                <li><a href="/" onClick={this.hide}>Close</a></li>
                            </ul>
                        </div>
                    </nav>
                    <div id="chatbot"  style={{ minHeight: 388, maxHeight: 388, width:'100%', overflow: 'auto'}}>
                    {this.renderMessages(this.state.messages)}
                        <div ref={(el) => { this.messagesEnd = el; }}
                             style={{ float:"left", clear: "both" }}>
                        </div>
                    </div>
                    <div className=" col s12" >
                        <input style={{margin: 0, paddingLeft: '1%', paddingRight: '1%', width: '98%'}} ref={(input) => { this.talkInput = input; }} placeholder="type a message:"  onKeyDown={this._handleInputKeyDown} id="user_says" type="text" />
                    </div>

                </div>
            );
        } else {
            return (
                <div style={{ minHeight: 40, maxHeight: 500, width:400, position: 'absolute', bottom: 0, right: 0, border: '1px solid lightgray'}}>
                    <nav>
                        <div className="nav-wrapper">
                            <a href="/" className="brand-logo">ChatBot</a>
                            <ul id="nav-mobile" className="right hide-on-med-and-down">
                                <li><a href="/" onClick={this.show}>Show</a></li>
                            </ul>
                        </div>
                    </nav>
                    <div ref={(el) => { this.messagesEnd = el; }}
                         style={{ float:"left", clear: "both" }}>
                    </div>
                </div>
                 );
                }
            }*/
           if (this.state.showBot) {
            return (
                <div class="container-fluid" style={{ minHeight: 500, maxHeight: 500, width:400, position: 'absolute', bottom: 0, right: 0, border: '1px solid lightgray'}}>
                   <div class="card" >
                   <nav class="navbar " style={{ backgroundColor:'#96be0d',border: '1px solid lightgray', height:'150px'}}>
                        <div >
                                                       
                            <h3 style={{ textAlign: 'center' , color:'white'}}>ChatBot</h3>  
                            <ul id="nav-mobile" style={{ textAlign: 'right', listStyleType: 'none', color:'white' }}>
                                <li><a href="/" style={{color:'white'}} onClick={this.hide}>Close</a></li>
                            </ul>
                        </div>
                    </nav>
                   
                                     
                    <div id="chatbot" class="card-title" style={{ minHeight: 388, maxHeight: 388, width:'100%', overflow: 'auto'}}>
                    {this.renderMessages(this.state.messages)}
                        <div ref={(el) => { this.messagesEnd = el; }}
                             style={{ float:"left", clear: "both" }}>
                        </div>
                    </div>
                    <div >
                        <input class="card-text" style={{margin: 0, paddingLeft: '1%', paddingRight: '1%', width: '98%'}} ref={(input) => { this.talkInput = input; }} placeholder="type a message:"  onKeyDown={this._handleInputKeyDown} id="user_says" type="text" />
                    </div>
                   </div>
                   </div>
            );
        } else {
            return (
                <div class="container" style={{ minHeight: 40, maxHeight: 500, width:400, position: 'absolute', bottom: 150, right: 100, border: '1px solid lightgray'}}>
                    <nav>
                        <div class="navbar " style={{ backgroundColor:'#96be0d',border: '1px solid lightgray',height:'150px'}}>
                        <h3 style={{ textAlign: 'center', color:'white' }}>ChatBot</h3> 
                            <ul id="nav-mobile"  style={{ textAlign: 'right', listStyleType: 'none', color:'white'}}>
                                <li><a href="/" style={{color:'white'}}  onClick={this.show}>Show</a></li>
                            </ul>
                        </div>
                    </nav>
                    <div ref={(el) => { this.messagesEnd = el; }}
                         style={{ float:"left", clear: "both" }}>
                    </div>
                </div>
                 );
                }
            }
        }

export default Chatbot;
